import { Pressable, StyleSheet, Text } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import { Icons } from 'components/Icons';
import { WebDiv } from 'components/WebDiv';

type ProfilePinEditButtonProps = {
  onPress: () => void;
};

export const ProfilePinEditButton = ({ onPress }: ProfilePinEditButtonProps) => {
  return (
    <WebDiv className="rounded-8">
      <Pressable accessibilityRole="button" onPress={onPress} style={styles.button}>
        <Text style={styles.buttonText}>Editar PIN de 4 dígitos</Text>
        <Icons.ChevronRight />
      </Pressable>
    </WebDiv>
  );
};

const styles = StyleSheet.create({
  button: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 7, 56, 0.3)',
    borderWidth: 3,
    borderColor: '#2240FF',
    borderRadius: 32,
    padding: calcSizeForDevice(10, 12),
  },
  buttonText: {
    fontSize: calcSizeForDevice(16),
    fontWeight: '500',
    color: '#FFF',
    marginRight: calcSizeForDevice(10),
  },
});
